module.exports = __webpack_public_path__ + "img/faultReport.205f1de2.jpg";